import { Store } from "../lib";
import { GoodsInRecurrence } from "../models";

export default class GoodsInRecurrencesStore extends Store {
  model = GoodsInRecurrence;
}
